import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Toast from "react-bootstrap/Toast"; // <-- Added Toast import
import "./ProblemSharePage.scss";
import * as api from "../../../services/apiService";

function ProblemSharePage() {
  const ProblemId = Number(useParams().ProblemId);
  const [emails, setEmails] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  
  // <-- Added state for the Toast
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const response = await api.getInstitutions();
        if (!response.ok) {
          throw new Error("Failed to fetch emails");
        }

        const data = await response.json();
        setEmails(data);
      } catch (error) {
        console.error("Error fetching emails:", error);
      }
    };

    fetchEmails();
  }, []);

  const handleCheckboxChange = (email) => {
    setSelectedEmails((prev) =>
      prev.includes(email)
        ? prev.filter((e) => e !== email)
        : [...prev, email]
    );
  };

  const handleSelectAll = () => {
    if (selectedEmails.length === emails.length) {
      setSelectedEmails([]);
    } else {
      setSelectedEmails(emails);
    }
  };

  const handleSend = async () => {
    if (selectedEmails.length === 0) {
      setToastMessage("Vă rugăm să selectați cel puțin o instituție.");
      setShowToast(true);
      return;
    }

    const request = {
      complaintId: ProblemId,
      institutionIds: selectedEmails.map((e) => e.id),
    };

    try {
      const response = await api.sendEmail(request);
      if (!response.ok) {
        throw new Error("Failed to send emails");
      }

      // <-- Replaced alert() with Toast
      setToastMessage("Email-urile au fost trimise cu succes!");
      setShowToast(true);

      setSelectedEmails([]);
    } catch (error) {
      console.error("Error sending emails:", error);
      // <-- Replaced alert() with Toast
      setToastMessage("A apărut o eroare la trimiterea email-urilor.");
      setShowToast(true);
    }
  };

  return (
    <div className="share-container">
      <h2 className="page-title">Pagina Distribuire</h2>

      <table className="email-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={emails.length > 0 && selectedEmails.length === emails.length}
                onChange={handleSelectAll}
              />
            </th>
            <th>Instituţii</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {emails.map((email, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedEmails.includes(email)}
                  onChange={() => handleCheckboxChange(email)}
                />
              </td>
              <td>{email.name}</td>
              <td>{email.contactEmail}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="send-btn" onClick={handleSend}>
        Trimite Email-uri
      </button>

      {/* <-- Added Toast Container at the bottom of the component --> */}
      <div className="toast-container-fixed">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={5000}
          autohide
          className="orange-toast"
        >
          <Toast.Header>
            <strong className="me-auto">Notificare</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </div>
    </div>
  );
}

export default ProblemSharePage;